import { DefaultTheme } from 'styled-components';

const zIndices: DefaultTheme['zIndices'] = {
  modal: 99999,
  dialogs: 9998,
  menus: 9990,
  header: 999,
  underHeader: 998,
  top: 99,
  over: 1,
  normal: 0,
  under: -1,
};

export default zIndices;
